import { Component } from '@angular/core';

@Component({
  selector: 'app-logout',
  template: `
    <div class="card col-12 mt-3 mb-3">
      <div class="card-block">

        <h1 class="card-title">Logged Out</h1>

        <div class="col-10 alert alert-success">
          You've been successfully logged out of the application.
        </div>

        <div class="m-3">
          <a routerLink="/login" routerLinkActive="active">Back to login</a>
        </div>

      </div>
    </div>
  `
})
export class LogoutSuccessComponent {}
